import React, { type InputHTMLAttributes, useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { Field } from "redux-form";
import InputRenderer from "src/shared/forms/formrenderers/InputRenderer";
import type IFormInputs from "src/shared/forms/inputs/IFormInputs";
import { length as Length } from "src/shared/forms/validations/Length";
import { required as Required } from "src/shared/forms/validations/Required";
import TextValidation from "src/shared/forms/validations/TextValidation";
import type { ValidationHandler } from "src/shared/forms/validations/ValidationHandler";

export interface IAddressInputProps
  extends IFormInputs,
    InputHTMLAttributes<HTMLInputElement> {
  isRequired?: boolean;
}

export default ({
  inputID,
  label = <FormattedMessage id="contacts.address1" />,
  validationDisabled = false,
  isRequired = false,
  ...rest
}: IAddressInputProps) => {
  const validations: ValidationHandler[] = useMemo(() => {
    if (validationDisabled) {
      return undefined;
    }
    const validations = [];
    if (isRequired) {
      validations.push(Required);
    }
    validations.push(Length(undefined, 128));
    validations.push(
      TextValidation(
        <FormattedMessage id="form.validations.address.invalid" />,
      ),
    );
    return validations;
  }, [isRequired, validationDisabled]);
  return (
    <Field
      name={inputID}
      label={label}
      type="text"
      component={InputRenderer}
      validate={validations}
      {...rest}
    />
  );
};
